import createActionTypes from './createActionTypes';

export const namespace = 'FLYERS';

export const types = createActionTypes(namespace, [
  'SET_CURRENT_FLYER',
  'SET_CURRENT_FLYER_NOT_FOUND',
  'SET_CURRENT_FLYER_STORES',
  // "SET_NEARBY_FLYERS",
  'RESET',
  'SET_CURRENT_FLYER_GIBS',
  'SET_FLYERS_PAGE_CONTENT_HEIGHT',
  'UPDATE_FLYERS_BY_LOCATION',
  'FETCH_FLYER_STORES',
  'SET_FLYER_STORES',
  'FETCH_CURRENT_FLYER',
  'FETCH_CURRENT_FLYER_STORE_OPENING_INFOS',
  'SET_CURRENT_FLYER_STORE_OPENING_INFOS',
]);

export const fetchCurrentFlyer = ({ flyerId, nearestStoreId, fetchTags, tagId }) => {
  return {
    type: types.FETCH_CURRENT_FLYER,
    payload: { flyerId, nearestStoreId, fetchTags, tagId },
  };
};

export const fetchCurrentFlyerStoreOpneingInfos = (flyerId, nearestStoreId) => {
  return {
    type: types.FETCH_CURRENT_FLYER_STORE_OPENING_INFOS,
    payload: { flyerId, nearestStoreId },
  };
};

export const setCurrentFlyer = (flyer) => ({
  type: types.SET_CURRENT_FLYER,
  payload: {
    flyer,
  },
});

export const setCurrentFlyerNotFound = (flyerId) => ({
  type: types.SET_CURRENT_FLYER_NOT_FOUND,
  payload: {
    flyerId,
  },
});

export const setCurrentFlyerStores = (storesList) => ({
  type: types.SET_CURRENT_FLYER_STORES,
  payload: {
    storesList,
  },
});

export const setFlyerStores = (flyerId, storesList, modalityFetchStore) => {
  return {
    type: types.SET_FLYER_STORES,
    payload: { flyerId, storesList, modalityFetchStore },
  };
};

export const setCurrentFlyerStoreOpeningInfos = (storeId, storeHours) => {
  return {
    type: types.SET_CURRENT_FLYER_STORE_OPENING_INFOS,
    payload: { storeId, storeHours },
  };
};
// export const setNearbyFlyers = (flyersList) => ({
//   type: types.SET_NEARBY_FLYERS,
//   payload: {
//     flyersList,
//   },
// });

export const fetchFlyerStores = (flyerId, parentFlyerId) => {
  return {
    type: types.FETCH_FLYER_STORES,
    payload: { flyerId, parentFlyerId },
  };
};

export const setCurrentFlyerGibs = (flyerGibs, flyerGibsChildIdsMap) => ({
  type: types.SET_CURRENT_FLYER_GIBS,
  payload: {
    flyerGibs,
    flyerGibsChildIdsMap,
  },
});

export const setFlyersPageContentHeight = (flyersPageContentHeight) => ({
  type: types.SET_FLYERS_PAGE_CONTENT_HEIGHT,
  payload: {
    flyersPageContentHeight,
  },
});

export const updateFlyersByLocation = (flyers, location) => ({
  type: types.UPDATE_FLYERS_BY_LOCATION,
  payload: { flyers, location },
});
